import { OnboardingGate } from "./OnboardingGate";
import { Loader2 } from "lucide-react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";

export function PrivateRoute({ children }: { children: React.ReactNode }) {
  const { currentUser, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div
        className="flex min-h-screen items-center justify-center bg-background px-6 text-sm text-muted-foreground"
        role="status"
        aria-live="polite"
      >
        <span className="inline-flex items-center gap-2.5">
          <Loader2
            className="h-4 w-4 animate-spin text-brand-ink motion-reduce:animate-[spin_1.8s_linear_infinite]"
            aria-hidden
          />
          Loading WaveGen…
        </span>
      </div>
    );
  }

  return currentUser ? (
    <OnboardingGate>{children}</OnboardingGate>
  ) : (
    <Navigate
      to={`/login?${new URLSearchParams({ returnTo: `${location.pathname}${location.search}${location.hash}` })}`}
      state={{ from: location }}
      replace
    />
  );
}
